import { StatTilesVariant } from '../shared/stat-tiles/stat-tiles';

// jobCategory is a closed set on the backend (domain-agency's
// AgentProfileJobCategory enum: Sales/PropertyManager/Principal/Administrator),
// but this GraphQL field surfaces the human-readable description string
// (e.g. "Sales representative"), not the enum token - hence the substring
// match rather than an exact-value switch.
//
// "Principal" has no agreed mapping to sales/rental/administrator in the
// design - flagged back to design. Falls back to 'sales' for now.
const getStatTilesVariant = (jobCategory?: string | null): StatTilesVariant => {
  const normalised = jobCategory?.toLowerCase() ?? '';

  if (normalised.includes('property manager')) {
    return 'rental';
  }

  if (normalised.includes('administrator')) {
    return 'administrator';
  }

  return 'sales';
};

export default getStatTilesVariant;
